import {Component, Inject} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';

@Component({
    selector: 'app-report-dialog',
    templateUrl: './report-dialog.component.html',
    styleUrls: ['./report-dialog.component.scss']
})
export class ReportDialogComponent {
    loadingReport = true;
    errorText: string | null = null;
    constructor(public dialogRef: MdDialogRef<ReportDialogComponent>, @Inject(MD_DIALOG_DATA) public runReport: ReportDialogData) {
      runReport().then(() => this.loadingReport = false).catch(e => {
        this.loadingReport = false;
        this.errorText = 'An error has occurred.'
      })
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    get hasError() {
      return !!this.errorText;
    }
}

export type ReportDialogData = () => Promise<any>;



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/report-dialog/report-dialog.component.ts